import React from 'react';
import { useGetMedicalbyIdQuery } from '../../../store/api/contact';

function DetailModal({ onclose, isopen, medicalinfoId }) {
  // Fetch the data using RTK Query hook
  const { data, isLoading, isError } = useGetMedicalbyIdQuery(medicalinfoId, {
    skip: !medicalinfoId, // Skip query if no ID
  });

  // If modal is not open, don't render it
  if (!isopen) return null;
    const BASE_URL = process.env.REACT_APP_API_URL.replace('/api', '');
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6 relative">
        {/* Close button */}
        <button
          onClick={onclose}
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-800 text-lg"
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold mb-4 text-gray-800">Medical Details</h2>

        {isLoading && <p className="text-gray-500">Loading...</p>}
        {isError && <p className="text-red-500">Failed to load data.</p>}

        {data && (
          <div className="space-y-2 text-sm text-gray-700">
            <p><strong>Name:</strong> {data.full_name}</p>
            <p><strong>Phone:</strong> {data.phone_number}</p>
            <p><strong>Address:</strong> {data.address}</p>
            <p><strong>Age:</strong> {data.age}</p>
            <p><strong>Gender:</strong> {data.gender}</p>
            <p><strong>Quotation:</strong> {data.quotation}</p>
            <p><strong>Conditions/Needs:</strong> {data.conditions_and_needs}</p>
            <p>
              <strong>Date:</strong>{' '}
              {new Date(data.created_at).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })}
            </p>
            {data.files && (
              <div className="mt-3">
                <p><strong>File:</strong></p>
                {data.files.endsWith('.pdf') ? (
                  <a
                    href={data.files}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 underline"
                  >
                    View PDF
                  </a>
                ) : (
                  <img
                     src={`${BASE_URL}${data.files}`}
                    alt="Uploaded Report"
                    className="w-40 h-40 object-cover rounded border"
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default DetailModal;
